import UserIcon from '@/public/images/dashboard/user.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export default function ClosedLeadsEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={UserIcon}
      title={Trans(
        translations,
        'HereYouWillSeeTheirClosingReasonsAndQualifications'
      )}
    />
  );
}
